// extracted by mini-css-extract-plugin
export default {"container":"Author_container__Z2DHz","img":"Author_img__hxJBb"};